import { React } from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import { RootLayout } from "../../layout";
import ListagemUsuarios from "./listagemUsuarios";
import { Typography } from "@mui/material";
import { getItemDecrypt } from "../../utils/cryptoData";

export default function MiniDrawer() {
  let vinculo = getItemDecrypt("vinculo_ativo");

  let administrador = vinculo.administrador;

  if (!administrador) {
    return (
      <Box>
        <CssBaseline />
        <RootLayout>
          <Typography
            component="h1"
            variant="h4"
            align="center"
            fontWeight={700}
            color="#063F5E"
            mt={10}
          >
            Você não tem permissão para acessar essa página
          </Typography>
        </RootLayout>
      </Box>
    );
  }
  return (
    <Box>
      <CssBaseline />

      <RootLayout>
        <ListagemUsuarios />
      </RootLayout>
    </Box>
  );
}
